import auth from './auth.json';
import common from './common.json';
import dashboard from './dashboard.json';
import dicts from './dicts.json';
import landings from './landings.json';
import nav from './nav.json';
import faq from './faq.json';
import news from './news.json';
import payments from './payments.json';
import referals from './referals.json';
import rules from './rules.json';
import settings from './settings.json';
import sources from './sources.json';
import stat from './stat.json';
import streams from './streams.json';
import support from './support.json';
import tds from './tds.json';

// Русский словарь — источник истины по составу ключей: en обязан повторять его
// один в один (проверяется shared/i18n/__tests__/locales.test.ts). Namespace =
// раздел кабинета; добавляя новый, не забыть такой же файл в locales/en и
// запись в NAMESPACES.
export default {
  auth,
  common,
  dashboard,
  dicts,
  faq,
  landings,
  nav,
  news,
  payments,
  referals,
  rules,
  settings,
  sources,
  stat,
  streams,
  support,
  tds,
} as const;
